















import { Component, Vue } from 'vue-property-decorator';
import navigation from '@/components/navbars/navigation.vue';
import footerNav from '@/components/navbars/footer.vue';

@Component({
	components: {
		footerNav,
		navigation,
	},
})
export default class AppLayoutDefault extends Vue {}
